import $ from 'jquery';
const TextareaElastic = {
    created() { },
    mounted(el, binding, vnode) {
        let elasticElement = el, $elasticElement = $(el), initialHeight = $elasticElement.height(), delta = parseInt($elasticElement.css('paddingBottom')) + parseInt($elasticElement.css('paddingTop')) || 0;
        const resize = function () {
            $elasticElement.height(initialHeight);
            $elasticElement.height(elasticElement.scrollHeight - delta);
        };
        $elasticElement.on('input change keyup', resize);
        resize();
    }
};
export default TextareaElastic;
